import React from 'react';

import { PageTitle, TextContent } from '../../index';

export default () => (
  <>
    <PageTitle>
    The CPD Learning Modules to be booked
    </PageTitle>
    <div style={{ margin: '20px 0px' }}>
      <TextContent>
      You will likely find that you won't need to take as many courses as the categories you've picked to renew. Our CPD courses are set up to cover several related topics at once, so you won't have to go over the same content again and again.
      </TextContent>
      <br/>
      <TextContent>
        (no factsheets are required for CPD e-learning)
      </TextContent>
    </div>
  </>
);
